import React, { useContext, useEffect, useState } from "react"
import { SectionContext } from "../context/sectionContext"
import { ErrorContext } from "../context/errorContext"
import {
} from "../../services/apiservice"
import { errorToastr } from "../../services/error-handler"
import { getOTP, verifyDeclarationOtp } from "../../services/apiservice"
import { getValueFromJourney ,getValueFromLookup} from "../services/helperFunctions"

export default function ComponentOTP(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [resetOtpCounter, setResetOtpCounter] = useState(0)
  const [generateOtpClicked, setGenerateOtpClicked] = useState(false)
  const [showLocalError, setShowLocalError] = useState(false)

  useEffect(() => {
    setErrorState(prev => {
      return ({
        ...prev,
        ["otpValidationError"]: "OTP not verified"
      })
    })
  }, [])

  useEffect(() => {
    const timer = resetOtpCounter > 0 && setInterval(() => setResetOtpCounter(resetOtpCounter - 1), 1000)
    return () => clearInterval(timer)
  }, [resetOtpCounter])

  const generateOtp = e => {
    if (sectionState.sectionData?.contactNumber
       && sectionState.sectionData?.email 
       && !errorState["email"]
       && !errorState["contactNumber"]) {
      let payloadForOtp = {
        mobileNumber: `${sectionState.sectionData.contactNumber}`,
        emailID:`${sectionState.sectionData.email}`,
        module: "CORPDISCOTPSMSEMAIL"
      }
      getOTP(payloadForOtp)
      .then(res => {
        setErrorState(prev => {
          return ({
            ...prev,
            ["otpValidationError"]: "Please enter OTP"
          })
        })
        setGenerateOtpClicked(true)
        setResetOtpCounter(30)
      })
      .catch(err => {
        console.log(err, "Error while generating otp")
      })
    }else{
      if(errorState["email"] === "Please enter valid corporate Email Address"){
        errorToastr("Please enter valid Mobile No & Email Id")
      }else{
        errorToastr("Please enter Mobile No & Email Id")
      } 
    }
  }
  
  const handleChangeOtp = ({target}) => {
    if (!isNaN(target.value)) {
      setSectionState(prev => {
        return ({
          ...prev, 
          sectionData: {
            ...prev.sectionData,
            ["corpDiscOtp"] : target.value
          }
        })
      })
      if (target.value.length < 6) {
        setErrorState(prev => {
          return {
            ...prev,
            ["otpValidationError"]: "Please enter 6 digit OTP number",
          }
        })
        setShowLocalError(true)
      } else {
        setErrorState(prev => {
          return {
            ...prev,
            ["otpValidationError"]: "",
          }
        })
      }
    }
  }

  const resendOTP = e => {
    if(generateOtpClicked){
      let payloadForOtp = {
        mobileNumber: `${sectionState.sectionData.contactNumber}`,
        emailID:`${sectionState.sectionData.email}`,
        module: "CORPDISCOTPSMSEMAIL"
      }
      getOTP(payloadForOtp)
      .then(res => {
        setSectionState(prev => {
          return ({
            ...prev, 
            sectionData: {
              ...prev.sectionData,
              ["corpDiscOtp"] : ""
            }
          })
        })
        setErrorState(prev => {
          return ({
            ...prev,
            ["otpValidationError"]: "Please enter correct OTP"
          })
        })
        setResetOtpCounter(30)
      })
      .catch(err => {
        setResetOtpCounter(30)
        console.log(err, "Error while generating otp")
      })
      
    }
  }

  const handleEnter = event => {
    if (event.key == "Enter") {
      generateOtp(event)
    }
  }

  return (
    <div className="cd-otp-box">
      <div className="field col-lg-4 col-md-4 col-4 cd-generate-otp-structure">
        <div className="otp-btn">
          {!generateOtpClicked && (
            <button
              className="otp-btnn"
              htmlFor={props.data.label}
              onClick={generateOtp}
              style={{
                color: "white",
                border: "none",
              }}
            >
              {(getValueFromLookup(
            "label",
            props.data.label
          )) || props.data.label}
            </button>
          )}
        </div>
        {generateOtpClicked && (
          <div className="cd-sent-otp">
              <span>
              OTP has been sent to your registered mobile number and corporate
              email id
            </span>
          </div>          
        )}
      </div>
      <div
        className={
          !generateOtpClicked ? "input-container-otp col-lg-8 col-md-8 col-8 field" : "input-container-sent-otp-box col-md-12 col-12 field"
        }
      >
        <div
        className={
          !generateOtpClicked ? "otp-text-box " : "otp-text-sent-box col-lg-12"
        }
        >
          <label htmlFor="Enter OTP" className={`input-label enter-otp${props.data.label ? "" : "no-label"} `}>
            Enter OTP
          </label>
          <input
            className={"form-control"}
            name="otp"
            type="text"
            placeholder="XXXXXX"
            required={true}
            disabled={generateOtpClicked ? false : true}
            onChange={handleChangeOtp}
            maxLength={6}
          ></input>
          {resetOtpCounter === 0 ? (
            <div style={{ cursor: "pointer" }} className="cd-resend-otp">
              <a
                tabIndex="0"
                onKeyPress={event => {
                  handleEnter(event)
                }}
                onClick={resendOTP}
              >
                RESEND OTP
              </a>
            </div>
          ) : (
            generateOtpClicked && (
              <div className="cd-resend-otp">
                <span className="fa">
                  RESEND OTP In {resetOtpCounter} seconds
                </span>
              </div>
            )
          )}

          {(props.showError || showLocalError) && (
            <div className="otp-length">
              <span>{errorState["otpValidationError"]}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
